import { HtmlController } from "../HTMLComponents/HtmlController";
import { Logger, NumberUtils } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { GameManager } from "./GameManager";
import { GameData } from "../Channels/Common/Datas/GameData";
import { DataManager } from "./DataManager";
import { ModuleManager } from "./ModuleManager";
import { HtmlDenomContainerElement } from "../HTMLComponents/Custom/HtmlDenomContainerElement";
import { HtmlBetSelectorContainerElement } from "../HTMLComponents/Custom/HtmlBetSelectorContainerElement";
import { HtmlBetSelectorContainerElement2 } from "../HTMLComponents/Custom/HtmlBetSelectorContainerElement2";
import { BalanceManager } from "./BalanceManager";
import { AppContext } from "../../Common/AppContext";
import { HtmlPaylineSelectorContainerElement } from "../HTMLComponents/Custom/HtmlPaylineSelectorContainerElement";
import { FreeRoundBonus } from "../Channels/Common/Bonuses/FreeRoundBonus";
import { BetHigherThanMinDialog } from "../Channels/Common/Dialogs/BetHigherThanMinDialog";

var SpinBet = Communication.Game.SpinBet;
var BetType = Communication.Game.BetType;

export class BetManager {
    static CoinSize: number;
    static CoinCount: number;
    static PaylineCount: number;
    static Bet: number;

    static Coins: { [coinSize: number]: Array<number> };

    static CoinSizes: Array<number>;
    static CoinCounts: Array<number>;
    static PaylineCounts: Array<number>;

    static DenomContainer: HtmlDenomContainerElement;
    static CoinCountContainer: HtmlBetSelectorContainerElement;
    static PaylineCountContainer: HtmlPaylineSelectorContainerElement;
    static BetContainer: HtmlBetSelectorContainerElement2;

    static min_Bet: boolean = false;
    static max_Bet: boolean = false;
    static minPayline: boolean = false;
    static maxPayline: boolean = false;
    static minBetPerLine: boolean = false;
    static maxBetPerLine: boolean = false;

    static initializeBet(): void {
        if (AppContext.current.getHideAmounts()) {
            this.hideValues(true);
        }
        if (GameManager.baseResponse.initData != null) {
            if (GameManager.baseResponse.initData.betSettings != null) {
                if (GameManager.baseResponse.initData.betSettings.coinSizes != null) {
                    BetManager.CoinSizes = GameManager.baseResponse.initData.betSettings.coinSizes;
                }
                if (GameManager.baseResponse.initData.betSettings.coinCounts != null) {
                    BetManager.CoinCounts = GameManager.baseResponse.initData.betSettings.coinCounts;
                }
                if (GameManager.baseResponse.initData.betSettings.paylineCounts != null) {
                    BetManager.PaylineCounts = GameManager.baseResponse.initData.betSettings.paylineCounts;
                }
            }

            if (
                GameManager.baseResponse.initData.betSettings != null &&
                GameManager.baseResponse.initData.betSettings.coins != null
            ) {
                BetManager.Coins = GameManager.baseResponse.initData.betSettings.coins;
            }

            if (GameManager.baseResponse.initData.lastBet != null) {
                if (
                    GameManager.baseResponse.initData.lastBet.betType === BetType.Payline &&
                    !AppContext.gameConfiguration.UseCoins
                ) {
                    if (
                        GameManager.baseResponse.initData.lastBet.coinSize != null &&
                        GameManager.baseResponse.initData.lastBet.coinCount != null &&
                        GameManager.baseResponse.initData.lastBet.paylineCount
                    ) {
                        if (
                            BetManager.Bet != null &&
                            BetManager.Bet !== GameManager.baseResponse.initData.lastBet.totalBet
                        ) {
                            ModuleManager.initNewBet();
                        } else {
                            ModuleManager.initNewBet(false);
                        }

                        BetManager.CoinSize = BetHigherThanMinDialog.getGameStartedWithoutFeature()
                            ? BetManager.CoinSizes[0]
                            : GameManager.baseResponse.initData.lastBet.coinSize;
                        DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
                        BetManager.CoinCount = BetHigherThanMinDialog.getGameStartedWithoutFeature()
                            ? BetManager.CoinCounts[0]
                            : GameManager.baseResponse.initData.lastBet.coinCount;
                        DataManager.updateGameDataFromModule(GameData.DataCointCount, BetManager.CoinCount.toString());
                        BetManager.PaylineCount = BetHigherThanMinDialog.getGameStartedWithoutFeature()
                            ? BetManager.PaylineCounts[0]
                            : GameManager.baseResponse.initData.lastBet.paylineCount;
                        DataManager.updateGameDataFromModule(
                            GameData.DataPaylineCount,
                            BetManager.PaylineCount.toString(),
                        );

                        BetManager.calculateBet();
                        DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
                        BetManager.updateBetPosition();
                    }
                } else {
                    if (GameManager.baseResponse.initData.lastBet.paylineCount) {
                        BetManager.PaylineCount = GameManager.baseResponse.initData.lastBet.paylineCount;
                        DataManager.updateGameDataFromModule(
                            GameData.DataPaylineCount,
                            GameManager.baseResponse.initData.lastBet.paylineCount.toString(),
                        );
                    }
                    if (!DataManager.GameRoundClosed) {
                        if (GameManager.baseResponse.initData.lastBet.coinSize != null) {
                            BetManager.CoinSize = GameManager.baseResponse.initData.lastBet.coinSize;
                            DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
                        }
                        if (GameManager.baseResponse.initData.lastBet.coinCount != null) {
                            BetManager.CoinCount = parseInt(
                                GameManager.baseResponse.initData.lastBet.coinCount.toString(),
                            );
                            DataManager.updateGameDataFromModule(
                                GameData.DataCointCount,
                                BetManager.CoinCount.toString(),
                            );
                        }
                        if (BetManager.CoinSize != null && BetManager.CoinCount != null) {
                            BetManager.calculateBet();
                            DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
                            if (
                                AppContext != null &&
                                AppContext.gameConfiguration != null &&
                                AppContext.gameConfiguration.UseCoins &&
                                BetManager.CoinSize != null
                            ) {
                                DataManager.updateGameDataFromModule(
                                    GameData.DataBetDenom,
                                    parseInt(
                                        NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString(),
                                    ).toString(),
                                );
                                DataManager.updateDataElement(
                                    GameData.DataBetDenom,
                                    parseInt(
                                        NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString(),
                                    ).toString(),
                                );
                            }
                        }
                        BalanceManager.recalculateDenomBalance();
                    } else if (AppContext.current.getDenomination() != null && BetManager.Coins != null) {
                        if (BetManager.Coins[AppContext.current.getDenomination()] != null) {
                            BetManager.changeDenom(AppContext.current.getDenomination(), true);
                        } else {
                            BetManager.changeDefaultDenom();
                        }
                    } else {
                        BetManager.changeDefaultDenom();
                    }
                    if (BetManager.CoinSize != null && BetManager.CoinCount != null) {
                        BetManager.calculateBet();
                        DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
                        if (
                            AppContext != null &&
                            AppContext.gameConfiguration != null &&
                            AppContext.gameConfiguration.UseCoins &&
                            BetManager.CoinSize != null
                        ) {
                            DataManager.updateGameDataFromModule(
                                GameData.DataBetDenom,
                                parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                            );
                            DataManager.updateDataElement(
                                GameData.DataBetDenom,
                                parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                            );
                        }
                    }
                }
            }
            ModuleManager.updatePaylines();
            if (BetManager.DenomContainer != null) {
                BetManager.DenomContainer.addValues();
            }

            if (BetManager.CoinCountContainer != null) {
                BetManager.CoinCountContainer.addValues();
            }

            if (BetManager.PaylineCountContainer != null) {
                BetManager.PaylineCountContainer.addValues();
            }

            if (BetManager.BetContainer != null) {
                BetManager.BetContainer.addValues();
            }
        }
    }

    static changeBet(
        coinSize: boolean,
        coinCount: boolean,
        paylineCount: boolean,
        decrease: boolean = false,
        max: boolean = false,
        cycle: boolean = false,
    ): void {
        BetHigherThanMinDialog.closeDialog(true);
        if (DataManager.GameRoundClosed) {
            FreeRoundBonus.enableUi();
        }

        BetManager.unHideValues();

        if (AppContext.gameConfiguration.UseCoins) {
            if (cycle) {
                BetManager.cycleCoinCount();
                return;
            } else if (max) {
                BetManager.maxCoinCount();
                return;
            }
        }

        if (max) {
            BetManager.maxBet();
            return;
        }

        var index: number;
        if (
            coinSize &&
            BetManager.CoinSize != null &&
            BetManager.CoinSizes != null &&
            BetManager.CoinSizes.length > 0
        ) {
            for (var i: number = 0; i < BetManager.CoinSizes.length; i++) {
                if (BetManager.CoinSize === BetManager.CoinSizes[i]) {
                    index = i;
                }
            }
            if (index != null) {
                if (decrease) {
                    if (index == 0) {
                        // TODO cycle index = BetManager.CoinSizes.length - 1;
                    } else {
                        index--;
                    }
                } else {
                    if (max) {
                        index = BetManager.CoinSizes.length - 1;
                    } else {
                        if (index == BetManager.CoinSizes.length - 1) {
                            if (cycle) {
                                index = 0;
                            }
                        } else {
                            index++;
                        }
                    }
                }

                BetManager.CoinSize = BetManager.CoinSizes[index];
                DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
            }
        }

        if (
            paylineCount &&
            BetManager.PaylineCount != null &&
            BetManager.PaylineCounts != null &&
            BetManager.PaylineCounts.length > 0
        ) {
            for (var i: number = 0; i < BetManager.PaylineCounts.length; i++) {
                if (BetManager.PaylineCount === BetManager.PaylineCounts[i]) {
                    index = i;
                }
            }
            if (index != null) {
                if (decrease) {
                    if (index == 0) {
                        // TODO cycle index = BetManager.CoinSizes.length - 1;
                    } else {
                        index--;
                    }
                } else {
                    if (max) {
                        index = BetManager.PaylineCounts.length - 1;
                    } else {
                        if (index == BetManager.PaylineCounts.length - 1) {
                            if (cycle) {
                                index = 0;
                            }
                        } else {
                            index++;
                        }
                    }
                }

                BetManager.PaylineCount = BetManager.PaylineCounts[index];
                DataManager.updateGameDataFromModule(GameData.DataPaylineCount, BetManager.PaylineCount.toString());
            }
        }

        BetManager.calculateBet();

        if (GameManager.gameResponse.balance != null && GameManager.gameResponse.balance.bonus != null) {
            if (GameManager.gameResponse.balance.bonus >= BetManager.Bet) {
                ModuleManager.changeBetColor(true);
            } else {
                ModuleManager.changeBetColor();
            }
        }
        DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
        if (
            AppContext != null &&
            AppContext.gameConfiguration != null &&
            AppContext.gameConfiguration.UseCoins &&
            BetManager.CoinSize != null
        ) {
            DataManager.updateGameDataFromModule(
                GameData.DataBetDenom,
                parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
            );
        }
        DataManager.updateDataElements();
        Platforms.Platforms.bet({
            totalBet: BetManager.Bet,
            maxBetAction: max,
            userAction: DataManager.getTrustedUserAction("BET_CHANGE"),
        });
        BetManager.updateBetPosition();
        ModuleManager.updatePaylines();
        if (BetManager.PaylineCountContainer != null) {
            BetManager.PaylineCountContainer.changeValue();
        }
        DataManager.updateDataElement(GameData.DataTotalWin, "0");
        BalanceManager.poolingBalance();
    }

    static maxBet(): void {
        BetManager.unHideValues();

        if (AppContext != null && AppContext.gameConfiguration != null && AppContext.gameConfiguration.UseCoins) {
            BetManager.maxCoinCount();
            return;
        }

        var win: number = parseFloat(DataManager.getDataById(GameData.DataTotalWin));
        if (DataManager.GameRoundClosed) {
            win = 0;
        }
        var credit: number = parseFloat(DataManager.getDataById(GameData.DataBalanceReal)) + win;
        var creditBonus: number = parseFloat(DataManager.getDataById(GameData.DataBalanceBonus));
        var hasEnoughCredit = false;

        if (!BetManager.hasEnoughCredit(credit, creditBonus)) {
            return;
        }

        BetManager.CoinCount = BetManager.CoinCounts[BetManager.CoinCounts.length - 1];
        BetManager.CoinSize = BetManager.CoinSizes[BetManager.CoinSizes.length - 1];
        BetManager.PaylineCount = BetManager.PaylineCounts[BetManager.PaylineCounts.length - 1];
        var bet: number = BetManager.CoinSize * BetManager.CoinCount * BetManager.PaylineCount;
        var foundBet: boolean = false;
        var i: number = 0;

        if (bet > creditBonus && bet > credit && !foundBet) {
            for (i = BetManager.CoinCounts.length - 1; i >= 0; i--) {
                if (!foundBet) {
                    BetManager.CoinCount = BetManager.CoinCounts[i];
                    bet = BetManager.CoinSize * BetManager.CoinCount * BetManager.PaylineCount;
                    if (bet <= creditBonus) {
                        foundBet = true;
                    }
                    if (bet <= credit) {
                        foundBet = true;
                    }
                }
            }

            if (!foundBet) {
                for (i = BetManager.CoinSizes.length - 1; i >= 0; i--) {
                    if (!foundBet) {
                        BetManager.CoinSize = BetManager.CoinSizes[i];
                        bet = BetManager.CoinSize * BetManager.CoinCount * BetManager.PaylineCount;
                        if (bet <= creditBonus) {
                            foundBet = true;
                        }
                        if (bet <= credit) {
                            foundBet = true;
                        }
                    }
                }
            }

            if (!foundBet) {
                for (i = BetManager.PaylineCounts.length - 1; i >= 0; i--) {
                    if (!foundBet) {
                        BetManager.PaylineCount = BetManager.PaylineCounts[i];
                        bet = BetManager.CoinSize * BetManager.CoinCount * BetManager.PaylineCount;
                        if (bet <= creditBonus) {
                            foundBet = true;
                        }
                        if (bet <= credit) {
                            foundBet = true;
                        }
                    }
                }
            }
        }

        DataManager.updateGameDataFromModule(GameData.DataCointCount, BetManager.CoinCount.toString());
        DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
        DataManager.updateGameDataFromModule(GameData.DataPaylineCount, BetManager.PaylineCount.toString());

        BetManager.calculateBet();

        if (GameManager.gameResponse.balance != null && GameManager.gameResponse.balance.bonus != null) {
            if (GameManager.gameResponse.balance.bonus >= BetManager.Bet) {
                ModuleManager.changeBetColor(true);
            } else {
                ModuleManager.changeBetColor();
            }
        }

        DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
        if (
            AppContext != null &&
            AppContext.gameConfiguration != null &&
            AppContext.gameConfiguration.UseCoins &&
            BetManager.CoinSize != null
        ) {
            DataManager.updateGameDataFromModule(
                GameData.DataBetDenom,
                parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
            );
            DataManager.updateDataElement(
                GameData.DataBetDenom,
                parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
            );
        }
        DataManager.updateDataElements();
        Platforms.Platforms.bet({
            totalBet: BetManager.Bet,
            maxBetAction: true,
            userAction: DataManager.getTrustedUserAction("BET_CHANGE"),
        });
        BetManager.updateBetPosition();
        ModuleManager.updatePaylines();
        if (BetManager.PaylineCountContainer != null) {
            BetManager.PaylineCountContainer.changeValue();
        }
        DataManager.updateDataElement(GameData.DataTotalWin, "0");
    }

    private static hasEnoughCredit(credit: number, creditBonus: number): boolean {
        let minCoinCount = BetManager.CoinCounts[0];
        let minCoinSize = BetManager.CoinSizes[0];
        let minPaylineCount = BetManager.PaylineCounts[0];
        let bet = parseFloat(NumberUtils.multiply(minCoinCount, NumberUtils.multiply(minCoinSize, minPaylineCount)));

        if (bet <= credit) {
            return true;
        }

        if (bet <= creditBonus) {
            return true;
        }

        return false;
    }

    static setPaylines(paylineCount: number): void {
        BetManager.unHideValues();

        BetManager.PaylineCount = paylineCount;
        BetManager.calculateBet();
        DataManager.updateGameDataFromModule(GameData.DataPaylineCount, BetManager.PaylineCount.toString());
        DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
        if (
            AppContext != null &&
            AppContext.gameConfiguration != null &&
            AppContext.gameConfiguration.UseCoins &&
            BetManager.CoinSize != null
        ) {
            DataManager.updateGameDataFromModule(
                GameData.DataBetDenom,
                parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
            );
            DataManager.updateDataElement(
                GameData.DataBetDenom,
                parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
            );
        }
        DataManager.updateDataElements();
        ModuleManager.updatePaylines();
        ModuleManager.selectPaylines();
        if (BetManager.PaylineCountContainer != null) {
            BetManager.PaylineCountContainer.changeValue();
        }
    }

    static sortNumber(a: any, b: any) {
        return a - b;
    }

    static changeDefaultDenom(): void {
        BetManager.unHideValues();

        if (BetManager.Coins != null) {
            let lowestDenom: number;
            for (let key in BetManager.Coins) {
                if (lowestDenom == null) {
                    lowestDenom = parseFloat(key);
                } else {
                    if (parseFloat(key) < lowestDenom) {
                        lowestDenom = parseFloat(key);
                    }
                }
            }

            BetManager.CoinSize = lowestDenom;
            AppContext.current.setDenomination(BetManager.CoinSize);

            BetManager.Coins[lowestDenom].sort(BetManager.sortNumber);

            let highestPaylineCount: number;
            for (let i: number = 0; i < BetManager.PaylineCounts.length; i++) {
                if (highestPaylineCount == null) {
                    highestPaylineCount = BetManager.PaylineCounts[i];
                } else {
                    if (BetManager.PaylineCounts[i] < highestPaylineCount) {
                        highestPaylineCount = BetManager.PaylineCounts[i];
                    }
                }
            }

            BetManager.PaylineCount = highestPaylineCount;

            BetManager.CoinCount = BetManager.Coins[lowestDenom][0];

            DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
            DataManager.updateGameDataFromModule(GameData.DataCointCount, BetManager.CoinCount.toString());
            DataManager.updateGameDataFromModule(GameData.DataPaylineCount, BetManager.PaylineCount.toString());

            BetManager.calculateBet();
            DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());

            DataManager.updateDataElement(GameData.DataCoinSize);
            DataManager.updateDataElement(GameData.DataCointCount);
            DataManager.updateDataElement(GameData.DataBet);
            Platforms.Platforms.bet({ totalBet: BetManager.Bet });

            if (
                AppContext != null &&
                AppContext.gameConfiguration != null &&
                AppContext.gameConfiguration.UseCoins &&
                BetManager.CoinSize != null
            ) {
                DataManager.updateGameDataFromModule(
                    GameData.DataBetDenom,
                    parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                );
                DataManager.updateDataElement(
                    GameData.DataBetDenom,
                    parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                );
            }

            if (BetManager.CoinCountContainer != null) {
                BetManager.CoinCountContainer.addValues();
            }
            BalanceManager.recalculateDenomBalance();
        }
    }

    static changeDenom(value: number, init: boolean = false): void {
        BetManager.unHideValues();

        if (BetManager.Coins != null && BetManager.Coins[value] != null) {
            BetManager.CoinSize = value;
            AppContext.current.setDenomination(BetManager.CoinSize);

            BetManager.Coins[value].sort(BetManager.sortNumber);

            if (!init && BetManager.CoinCount != null && !AppContext.gameConfiguration.ResetCoinCountOnDenomChange) {
                let found: boolean = false;
                let coinCount: number = BetManager.CoinCount;
                for (let i: number = 0; i < BetManager.Coins[value].length; i++) {
                    if (BetManager.Coins[value][i] <= BetManager.CoinCount) {
                        found = true;
                        coinCount = BetManager.Coins[value][i];
                    }
                }

                if (!found) {
                    BetManager.CoinCount = BetManager.Coins[value][0];
                } else {
                    BetManager.CoinCount = coinCount;
                }
            } else {
                if (init) {
                    let highestPaylineCount: number;
                    for (let i: number = 0; i < BetManager.PaylineCounts.length; i++) {
                        if (highestPaylineCount == null) {
                            highestPaylineCount = BetManager.PaylineCounts[i];
                        } else {
                            if (BetManager.PaylineCounts[i] > highestPaylineCount) {
                                highestPaylineCount = BetManager.PaylineCounts[i];
                            }
                        }
                    }

                    BetManager.PaylineCount = highestPaylineCount;
                    DataManager.updateGameDataFromModule(GameData.DataPaylineCount, BetManager.PaylineCount.toString());
                }
                BetManager.CoinCount = BetManager.Coins[value][0];
            }

            DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
            DataManager.updateGameDataFromModule(GameData.DataCointCount, BetManager.CoinCount.toString());
            BetManager.calculateBet();
            DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());

            DataManager.updateDataElement(GameData.DataCoinSize);
            DataManager.updateDataElement(GameData.DataCointCount);
            DataManager.updateDataElement(GameData.DataBet);
            Platforms.Platforms.bet({ totalBet: BetManager.Bet });

            if (
                AppContext != null &&
                AppContext.gameConfiguration != null &&
                AppContext.gameConfiguration.UseCoins &&
                BetManager.CoinSize != null
            ) {
                DataManager.updateGameDataFromModule(
                    GameData.DataBetDenom,
                    parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                );
                DataManager.updateDataElement(
                    GameData.DataBetDenom,
                    parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                );
            }

            if (BetManager.CoinCountContainer != null) {
                BetManager.CoinCountContainer.addValues();
            }
            BalanceManager.recalculateDenomBalance();
        }

        if (DataManager.HelpDataGameLimit != 0) {
            if (
                AppContext != null &&
                AppContext.gameConfiguration != null &&
                AppContext.gameConfiguration.UseCoins &&
                BetManager.CoinSize != null
            ) {
                DataManager.updateGameDataFromModule(
                    GameData.DataHelpGameLimit,
                    parseInt(
                        NumberUtils.devide(DataManager.HelpDataGameLimit, BetManager.CoinSize).toString(),
                    ).toString(),
                );
                DataManager.updateDataElement(
                    GameData.DataHelpGameLimit,
                    parseInt(
                        NumberUtils.devide(DataManager.HelpDataGameLimit, BetManager.CoinSize).toString(),
                    ).toString(),
                );
            }
        }

        if (DataManager.HelpDataGambleLimit != 0) {
            if (
                AppContext != null &&
                AppContext.gameConfiguration != null &&
                AppContext.gameConfiguration.UseCoins &&
                BetManager.CoinSize != null
            ) {
                DataManager.updateGameDataFromModule(
                    GameData.DataHelpGambleLimit,
                    parseInt(
                        NumberUtils.devide(DataManager.HelpDataGambleLimit, BetManager.CoinSize).toString(),
                    ).toString(),
                );
                DataManager.updateDataElement(
                    GameData.DataHelpGambleLimit,
                    parseInt(
                        NumberUtils.devide(DataManager.HelpDataGambleLimit, BetManager.CoinSize).toString(),
                    ).toString(),
                );
            }
        }
    }

    static changeBetByValue(value: number): void {
        BetManager.unHideValues();
        var bonus: number = parseFloat(DataManager.getDataById(GameData.DataBalanceBonus));
        BetManager.Bet = value;

        if (bonus != null) {
            if (bonus >= BetManager.Bet) {
                ModuleManager.changeBetColor(true);
            } else {
                ModuleManager.changeBetColor();
            }
        }

        DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
        DataManager.updateDataElement(GameData.DataBet);
        Platforms.Platforms.bet({ totalBet: BetManager.Bet });

        if (
            AppContext != null &&
            AppContext.gameConfiguration != null &&
            AppContext.gameConfiguration.UseCoins &&
            BetManager.CoinSize != null
        ) {
            DataManager.updateGameDataFromModule(
                GameData.DataBetDenom,
                parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
            );
            DataManager.updateDataElement(
                GameData.DataBetDenom,
                parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
            );
        }

        BetManager.updateBetPosition();
    }

    static changeCoinCount(value: number): void {
        BetManager.unHideValues();

        if (BetManager.Coins != null) {
            if (BetManager.CoinSize != null) {
                BetManager.CoinCount = value;
                DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
                DataManager.updateGameDataFromModule(GameData.DataCointCount, BetManager.CoinCount.toString());
                BetManager.calculateBet();
                DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
                DataManager.updateDataElement(GameData.DataCoinSize);
                DataManager.updateDataElement(GameData.DataCointCount);
                DataManager.updateDataElement(GameData.DataBet);
                Platforms.Platforms.bet({ totalBet: BetManager.Bet });
                if (
                    AppContext != null &&
                    AppContext.gameConfiguration != null &&
                    AppContext.gameConfiguration.UseCoins &&
                    BetManager.CoinSize != null
                ) {
                    DataManager.updateGameDataFromModule(
                        GameData.DataBetDenom,
                        parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                    );
                    DataManager.updateDataElement(
                        GameData.DataBetDenom,
                        parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                    );
                }
            }
        }
    }

    static cycleCoinCount(): void {
        BetManager.unHideValues();

        if (BetManager.Coins != null) {
            if (BetManager.CoinSize != null && BetManager.CoinCount != null) {
                let index: number = 0;
                let coinSizes: Array<number> = [];
                for (let i: number = 0; i < BetManager.Coins[BetManager.CoinSize].length; i++) {
                    coinSizes.push(BetManager.Coins[BetManager.CoinSize][i]);
                }
                coinSizes.sort(BetManager.sortNumber);
                for (let i: number = 0; i < coinSizes.length; i++) {
                    if (BetManager.CoinCount === coinSizes[i]) {
                        index = i;
                    }
                }

                if (coinSizes[index + 1] != null) {
                    BetManager.CoinCount = coinSizes[index + 1];
                } else {
                    BetManager.CoinCount = coinSizes[0];
                }

                DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
                DataManager.updateGameDataFromModule(GameData.DataCointCount, BetManager.CoinCount.toString());
                BetManager.calculateBet();
                DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());

                DataManager.updateDataElement(GameData.DataCoinSize);
                DataManager.updateDataElement(GameData.DataCointCount);
                DataManager.updateDataElement(GameData.DataBet);
                Platforms.Platforms.bet({ totalBet: BetManager.Bet });

                if (
                    AppContext != null &&
                    AppContext.gameConfiguration != null &&
                    AppContext.gameConfiguration.UseCoins &&
                    BetManager.CoinSize != null
                ) {
                    DataManager.updateGameDataFromModule(
                        GameData.DataBetDenom,
                        parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                    );
                    DataManager.updateDataElement(
                        GameData.DataBetDenom,
                        parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                    );
                }
            }
        }
    }

    static maxCoinCount(): void {
        BetManager.unHideValues();

        if (BetManager.Coins != null) {
            if (BetManager.CoinSize != null && BetManager.CoinCount != null) {
                let credit: number = parseFloat(DataManager.getDataById(GameData.DataBalanceReal));
                let bet: number = 0;
                let coinCount: number = BetManager.CoinCount;
                let paylineCount: number = BetManager.PaylineCount;

                BetManager.Coins[BetManager.CoinSize].sort(BetManager.sortNumber);

                for (let i: number = 0; i < BetManager.Coins[BetManager.CoinSize].length; i++) {
                    bet =
                        parseFloat(
                            NumberUtils.multiply(BetManager.CoinSize, BetManager.Coins[BetManager.CoinSize][i]),
                        ) * BetManager.PaylineCount;
                    if (credit >= bet) {
                        coinCount = BetManager.Coins[BetManager.CoinSize][i];
                    }
                }

                let testBet: number =
                    parseFloat(NumberUtils.multiply(BetManager.CoinSize, BetManager.Coins[BetManager.CoinSize][0])) *
                    BetManager.PaylineCount;

                if (credit < testBet) {
                    coinCount = BetManager.Coins[BetManager.CoinSize][0];
                }

                BetManager.CoinCount = coinCount;
                bet = parseFloat(NumberUtils.multiply(BetManager.CoinSize, coinCount)) * BetManager.PaylineCount;

                if (credit < bet) {
                    BetManager.PaylineCounts.sort(BetManager.sortNumber);
                    for (let i: number = 0; i < BetManager.PaylineCounts.length; i++) {
                        bet =
                            parseFloat(NumberUtils.multiply(BetManager.CoinSize, coinCount)) *
                            BetManager.PaylineCounts[i];
                        if (credit >= bet) {
                            paylineCount = BetManager.PaylineCounts[i];
                        }
                    }
                }

                if (BetManager.PaylineCount != paylineCount) {
                    BetManager.setPaylines(paylineCount);
                }

                BetManager.PaylineCount = paylineCount;

                DataManager.updateGameDataFromModule(GameData.DataCoinSize, BetManager.CoinSize.toString());
                DataManager.updateGameDataFromModule(GameData.DataCointCount, BetManager.CoinCount.toString());
                DataManager.updateGameDataFromModule(GameData.DataPaylineCount, BetManager.PaylineCount.toString());

                BetManager.calculateBet();
                DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());

                DataManager.updateDataElement(GameData.DataCoinSize);
                DataManager.updateDataElement(GameData.DataCointCount);
                DataManager.updateDataElement(GameData.DataPaylineCount);
                DataManager.updateDataElement(GameData.DataBet);
                Platforms.Platforms.bet({ totalBet: BetManager.Bet });

                if (
                    AppContext != null &&
                    AppContext.gameConfiguration != null &&
                    AppContext.gameConfiguration.UseCoins &&
                    BetManager.CoinSize != null
                ) {
                    DataManager.updateGameDataFromModule(
                        GameData.DataBetDenom,
                        parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                    );
                    DataManager.updateDataElement(
                        GameData.DataBetDenom,
                        parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                    );
                }

                if (
                    AppContext != null &&
                    AppContext.gameConfiguration != null &&
                    AppContext.gameConfiguration.UseCoins &&
                    BetManager.CoinSize != null
                ) {
                    DataManager.updateGameDataFromModule(
                        GameData.DataBetDenom,
                        parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                    );
                    DataManager.updateDataElement(
                        GameData.DataBetDenom,
                        parseInt(NumberUtils.devide(BetManager.Bet, BetManager.CoinSize).toString()).toString(),
                    );
                }
            }
        }
    }

    static updateBetPosition(): void {
        let sizes: number;
        let counts: number;

        if (BetManager.CoinSizes != null) {
            for (let i: number = 0; i < BetManager.CoinSizes.length; i++) {
                if (BetManager.CoinSize === BetManager.CoinSizes[i]) {
                    if (i <= 0) {
                        BetManager.minBetPerLine = true;
                        BetManager.maxBetPerLine = false;
                    } else if (i >= BetManager.CoinSizes.length - 1) {
                        BetManager.minBetPerLine = false;
                        BetManager.maxBetPerLine = true;
                    } else {
                        BetManager.minBetPerLine = false;
                        BetManager.maxBetPerLine = false;
                    }

                    sizes = i + 1;
                    DataManager.updateGameDataFromModule(
                        GameData.DataCoinSizePosition,
                        i + 1 + "/" + BetManager.CoinSizes.length,
                    );
                    DataManager.updateDataElement(GameData.DataCoinSizePosition);
                }
            }
        }

        if (BetManager.PaylineCounts != null) {
            for (let i: number = 0; i < BetManager.PaylineCounts.length; i++) {
                if (BetManager.PaylineCount === BetManager.PaylineCounts[i]) {
                    if (i <= 0) {
                        BetManager.minPayline = true;
                        BetManager.maxPayline = false;
                    } else if (i >= BetManager.PaylineCounts.length - 1) {
                        BetManager.minPayline = false;
                        BetManager.maxPayline = true;
                    } else {
                        BetManager.minPayline = false;
                        BetManager.maxPayline = false;
                    }

                    counts = i + 1;
                    DataManager.updateGameDataFromModule(
                        GameData.DataPaylineCountPosition,
                        i + 1 + "/" + BetManager.PaylineCounts.length,
                    );
                    DataManager.updateDataElement(GameData.DataPaylineCountPosition);
                }
            }
        }

        if (BetManager.minPayline && BetManager.minBetPerLine) {
            BetManager.min_Bet = true;
            BetManager.max_Bet = false;
        } else if (BetManager.maxPayline && BetManager.maxBetPerLine) {
            BetManager.min_Bet = false;
            BetManager.max_Bet = true;
        } else {
            BetManager.min_Bet = false;
            BetManager.max_Bet = false;
        }

        if (sizes != null && counts != null) {
            DataManager.updateGameDataFromModule(
                GameData.DataBetPosition,
                sizes + counts + "/" + (BetManager.CoinSizes.length + BetManager.PaylineCounts.length),
            );
            DataManager.updateDataElement(GameData.DataBetPosition);
        }
    }

    static unHideValues(credit: boolean = false): void {
        for (let i = 0; i < HtmlController.HideButtons.length; i++) {
            HtmlController.HideButtons[i].unHide(credit);
        }
    }

    static hideValues(credit: boolean = false): void {
        for (let i = 0; i < HtmlController.HideButtons.length; i++) {
            HtmlController.HideButtons[i].hide(credit);
        }
    }

    static createBetForSpin(): Communication.Game.SpinBet {
        return new SpinBet(BetType.Payline, BetManager.CoinSize, BetManager.CoinCount, BetManager.PaylineCount, null);
    }

    private static log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup("BetManager", s);
        }
    }
    private static calculateBet(): void {
        let betPerLine: number = parseFloat(NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
        let bet: number = parseFloat(NumberUtils.multiply(betPerLine, BetManager.PaylineCount));
        BetManager.Bet = bet;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Managers/BetManager.ts
 **/